module.exports = __webpack_public_path__ + "static/media/contratoservicios.2d8a99d5.svg";